import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import Login from './Login'
import { AuthActions, AuthSelectors } from '../reducers/AuthRedux'
import hasPermission from 'src/utils/hasPermissions'

export const RequireAuth = ({permission, children }) => {

  const isAuthenticated = useSelector(AuthSelectors.isAuthenticated)
  const user = useSelector(AuthSelectors.getUser)
  
  let location = useLocation()

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if(!hasPermission(user, permission))
  {
    return <Navigate to="/" replace />
  }

  return children
}

export const PerformAuth = () => {
  const dispatch = useDispatch()
  const isAuthenticated = useSelector(AuthSelectors.isAuthenticated)
  const isAuthenticating = useSelector(AuthSelectors.isAuthenticating)
  const error = useSelector(AuthSelectors.error)
  const problem = useSelector(AuthSelectors.problem)

  let location = useLocation()

  const handleLogin = (credentials) => {
    const payload = {
      ...credentials,
      strategy: 'local',
    }
    dispatch(AuthActions.loginRequest(payload))
  }


  if (isAuthenticated) {
    const { from } = location.state || { from: { pathname: '/' } }
    return <Navigate to={from} />
  }

  return <Login onLogin={handleLogin} isAuthenticating={isAuthenticating} error={error} problem={problem}/>
}